<script setup>
import CLink from "@/Components/CLink.vue"
import {usePage} from "@inertiajs/vue3"

const page = usePage()
const props = defineProps({
    selectedCategory: Object
})
</script>

<template>
    <v-sheet class="ma-3 mb-5" max-height="300" height="auto" v-if="selectedCategory && selectedCategory.children_categories.length > 0">
        <p class="pb-4">Sub Categorias</p>
        <v-slide-group direction="vertical" prev-icon="mdi-chevron-up" next-icon="mdi-chevron-down">
            <v-slide-group-item v-for="category in selectedCategory.children_categories" :key="category.id">
                <c-link :href="route('product.category', {...route().params, category})">
                    <v-icon icon="mdi-chevron-right"/>
                    {{ category.title }}
                </c-link>
                <v-divider  class="pa-2"/>
            </v-slide-group-item>
        </v-slide-group>
    </v-sheet>
</template>
